"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLookupComparisonsForTargetField = exports.replaceWithLookupSlug = exports.generateLookupStubRecords = exports.prepareValueForClipboardFromTargetField = exports.getSearchKeyFromTargetField = exports.getSortKeyFromTargetField = exports.getGroupBySortKeyFromTargetField = exports.isTargetFieldValueEmpty = exports.getGroupByKeyFromTargetField = exports.getValueToStringFromTargetField = exports.getReferencedRecordsFromLinkedField = exports.getReferencedRecordsFromTargetField = exports.getGroupValuesFromTargetField = exports.mergeLookupGroups = exports.isNegativeComparison = void 0;
const mapValues_1 = __importDefault(require("lodash-es/mapValues"));
const fields_logic_registry_1 = require("../field-type-registry/fields-logic-registry");
const comparisons_1 = require("../comparisons/comparisons");
const fields_1 = require("./fields");
const filter_1 = require("./filter");
const target_field_1 = require("./target-field");
const filter_2 = require("../filter/filter");
const guuid_1 = require("../testing/guuid");
const flatten_1 = __importDefault(require("lodash-es/flatten"));
const isNegativeComparison = (comparison) => {
    return [
        "is_not",
        "is_not_empty",
        "not_contains",
        "is_not_equal_to",
        "is_none_of",
        "has_none_of",
    ].includes(comparison);
};
exports.isNegativeComparison = isNegativeComparison;
const mergeLookupGroups = (fieldValue) => {
    return fieldValue.reduce((result, group) => {
        result.push(...group);
        return result;
    }, []);
};
exports.mergeLookupGroups = mergeLookupGroups;
const mergeLookupGroupsFillEmptyWith = (fieldValue, emptyValue) => {
    return fieldValue.reduce((result, group) => {
        if (group.length) {
            result.push(...group);
        }
        else {
            result.push(emptyValue);
        }
        return result;
    }, []);
};
const getGroupValuesFromTargetField = (fieldValue, field, record, userPreferences) => {
    return (0, target_field_1.withTargetField)(field, [], (targetField, targetFieldLogic) => {
        const recordValues = (0, exports.mergeLookupGroups)(fieldValue);
        const targetValues = recordValues.reduce((result, targetFieldValue) => {
            const targetGroupValues = targetFieldLogic.getGroupValues(targetFieldValue, targetField, record, userPreferences);
            result.push(...targetGroupValues);
            return result;
        }, []);
        return (0, filter_2.filterByUniqueGroupKey)(targetValues, targetField, userPreferences).map((valueItem) => [[valueItem]]);
    });
};
exports.getGroupValuesFromTargetField = getGroupValuesFromTargetField;
const getReferencedRecordsFromTargetField = (fieldValue, field, record, structure) => {
    return (0, target_field_1.withTargetField)(field, [], (targetField, targetFieldLogic) => {
        const recordValues = (0, exports.mergeLookupGroups)(fieldValue);
        const stubRecord = { ...record };
        return recordValues
            .map((targetFieldValue) => {
            stubRecord[targetField.slug] = targetFieldValue;
            return targetFieldLogic.getReferencedRecords(targetFieldValue, targetField, stubRecord, structure);
        })
            .reduce((prev, curr) => {
            prev.push(...curr);
            return prev;
        }, [])
            .filter(filter_1.filterUniqueValues);
    });
};
exports.getReferencedRecordsFromTargetField = getReferencedRecordsFromTargetField;
const getReferencedRecordsFromLinkedField = (field, record, structure) => {
    var _a;
    const linkedField = (0, fields_1.getAppFieldBySlug)(structure, (_a = field.params.linked_field) !== null && _a !== void 0 ? _a : "");
    if (!linkedField) {
        return [];
    }
    const linkedFieldLogic = (0, fields_logic_registry_1.getFieldLogic)(linkedField.field_type);
    const linkedFieldValue = (0, fields_1.getValueFromRecordByField)(record, linkedField);
    return linkedFieldLogic.getReferencedRecords(linkedFieldValue, linkedField, record, structure);
};
exports.getReferencedRecordsFromLinkedField = getReferencedRecordsFromLinkedField;
const getValueToStringFromTargetField = (fieldValue, field, userPreferences, record, separator = " | ") => {
    return (0, target_field_1.withTargetField)(field, "", (targetField, targetFieldLogic) => {
        const recordValues = (0, exports.mergeLookupGroups)(fieldValue);
        // @ts-expect-error: Need to resolve
        const stubRecord = { ...record };
        return recordValues
            .map((targetFieldValue) => {
            stubRecord[targetField.slug] = targetFieldValue;
            return targetFieldLogic.valueToString(targetFieldValue, targetField, userPreferences, stubRecord);
        })
            .filter((value) => !!value)
            .join(separator);
    });
};
exports.getValueToStringFromTargetField = getValueToStringFromTargetField;
const getGroupByKeyFromTargetField = (fieldValue, field, userPreferences, record, structure) => {
    return (0, target_field_1.withTargetField)(field, "", (targetField, targetFieldLogic) => {
        const recordValues = (0, exports.mergeLookupGroups)(fieldValue);
        // @ts-expect-error: Need to resolve
        const stubRecord = { ...record };
        return recordValues
            .filter((targetFieldValue) => !targetFieldLogic.isValueEmpty(targetFieldValue, targetField))
            .map((targetFieldValue) => {
            stubRecord[targetField.slug] = targetFieldValue;
            return targetFieldLogic.groupByKey(targetFieldValue, targetField, userPreferences, stubRecord, structure);
        })
            .filter((groupByKey) => {
            const isEmptyKey = groupByKey === undefined ||
                groupByKey === null ||
                groupByKey === "";
            return !isEmptyKey;
        })
            .filter(filter_1.filterUniqueValues)
            .join(" | ");
    });
};
exports.getGroupByKeyFromTargetField = getGroupByKeyFromTargetField;
const isTargetFieldValueEmpty = (fieldValue, field) => {
    return (0, target_field_1.withTargetField)(field, true, (targetField, targetFieldLogic) => {
        const recordValues = (0, exports.mergeLookupGroups)(fieldValue);
        for (const value of recordValues) {
            if (!targetFieldLogic.isValueEmpty(value, targetField)) {
                return false;
            }
        }
        return true;
    });
};
exports.isTargetFieldValueEmpty = isTargetFieldValueEmpty;
const getGroupBySortKeyFromTargetField = (fieldValue, field, userPreferences, record, structure, rule) => {
    return (0, target_field_1.withTargetField)(field, [], (targetField, targetFieldLogic) => {
        const recordValues = (0, exports.mergeLookupGroups)(fieldValue);
        const stubRecord = { ...record };
        return recordValues.map((targetFieldValue) => {
            stubRecord[targetField.slug] = targetFieldValue;
            return targetFieldLogic.groupBySortKey(targetFieldValue, targetField, userPreferences, stubRecord, structure, rule);
        });
    });
};
exports.getGroupBySortKeyFromTargetField = getGroupBySortKeyFromTargetField;
const getSortKeyFromTargetField = (fieldValue, field, userPreferences, record, structure, rule) => {
    return (0, target_field_1.withTargetField)(field, [], (targetField, targetFieldLogic) => {
        const specialSortingKey = getSpecialSortingKey(fieldValue, targetField);
        if (specialSortingKey !== undefined) {
            return [specialSortingKey];
        }
        const recordValues = mergeLookupGroupsFillEmptyWith(fieldValue, targetFieldLogic.getEmptyValue());
        const stubRecord = { ...record };
        return recordValues.map((targetFieldValue) => {
            stubRecord[targetField.slug] = targetFieldValue;
            return targetFieldLogic.sortKey(targetFieldValue, targetField, userPreferences, stubRecord, structure, rule);
        });
    });
};
exports.getSortKeyFromTargetField = getSortKeyFromTargetField;
const getSearchKeyFromTargetField = (fieldValue, field, userPreferences, record) => {
    return (0, target_field_1.withTargetField)(field, "", (targetField, targetFieldLogic) => {
        const recordValues = (0, exports.mergeLookupGroups)(fieldValue);
        return recordValues
            .map((targetFieldValue) => targetFieldLogic.searchKey(targetFieldValue, targetField, userPreferences, record))
            .filter((searchKey) => !!searchKey)
            .filter(filter_1.filterUniqueValues)
            .join(" | ");
    });
};
exports.getSearchKeyFromTargetField = getSearchKeyFromTargetField;
const prepareValueForClipboardFromTargetField = (fieldValue, field, userPreferences, record) => {
    const recordValues = (0, exports.mergeLookupGroups)(fieldValue);
    const flattenValue = (0, flatten_1.default)(recordValues);
    const defaultValue = {
        text: "",
        rawValue: flattenValue,
    };
    return (0, target_field_1.withTargetField)(field, defaultValue, (targetField, targetFieldLogic) => {
        var _a;
        const isFieldValueArray = Array.isArray((_a = targetField.params) === null || _a === void 0 ? void 0 : _a.default_value);
        const delimiter = isFieldValueArray ? "; " : ", ";
        const textParts = [];
        const rawValueArray = [];
        for (const targetFieldValue of recordValues) {
            const result = targetFieldLogic.prepareValueForClipboard(targetFieldValue, targetField, userPreferences, record);
            textParts.push(result.text);
            if (Array.isArray(result.rawValue)) {
                rawValueArray.push(...result.rawValue);
            }
            else {
                rawValueArray.push(result.rawValue);
            }
        }
        return {
            text: textParts.join(delimiter),
            rawValue: rawValueArray,
        };
    });
};
exports.prepareValueForClipboardFromTargetField = prepareValueForClipboardFromTargetField;
/**
 * Check whether special sorting rule should apply and return an appropriate key.
 */
function getSpecialSortingKey(fieldValue, targetField) {
    if (!fieldValue.length && targetField.field_type === "yesnofield") {
        return getSpecialSortKeyForYesNoField();
    }
    return undefined;
}
function getSpecialSortKeyForYesNoField() {
    /*
     * There is only one exception to sorting by yes/no field.
     * When there are no linked records,
     * empty value should be moved to the end in asc sorting,
     * and to the beginning at the desc sorting.
     * Filled values have keys like [0, 1 , 0, 1 , 0 , 1], etc.
     * This key is always greater than 0 or 1 in any combinations.
     * Reference:
     * https://en.wikipedia.org/wiki/Lexicographic_order
     * */
    return 9;
}
/**
 * Generates stub records for displaying the value of the Lookup field, since
 * no access to original records, but it is possible to recreate records from
 * the value of the Lookup field.
 */
const generateLookupStubRecords = (lookupValue, targetField, recordTemplate) => {
    if (!lookupValue || !targetField) {
        return [];
    }
    return lookupValue.map((item) => ({
        first_created: { by: "", on: "" },
        last_updated: { by: "", on: "" },
        comments_count: 0,
        followed_by: [],
        ...recordTemplate,
        id: (0, guuid_1.guid)(),
        [targetField.slug]: item,
    }));
};
exports.generateLookupStubRecords = generateLookupStubRecords;
const replaceWithLookupSlug = (lookupField, field) => {
    if (field.parent) {
        return { ...field, parent: { ...field.parent, slug: lookupField.slug } };
    }
    return { ...field, slug: lookupField.slug };
};
exports.replaceWithLookupSlug = replaceWithLookupSlug;
const getComparisonSafely = (comparisons, comparison) => {
    var _a;
    return (_a = comparisons[comparison]) !== null && _a !== void 0 ? _a : comparisons_1.noopGenerator;
};
const lookupYesNoIsComparison = (comparisons) => {
    const is = getComparisonSafely(comparisons, "is");
    return (filterValue) => {
        return filterValue
            ? (0, comparisons_1.forListSome)(is)(filterValue)
            : (0, comparisons_1.forListSomeOrEmpty)(is)(filterValue);
    };
};
/**
 * Returns a dict of comparisons. There are fields with specific filtering behavior such as
 * ColorPicker and AssignTo fields. It provides individual processing of comparisons for them.
 */
const getLookupComparisonsForTargetField = (fieldType, comparisons) => {
    const is = getComparisonSafely(comparisons, "is");
    const isNot = getComparisonSafely(comparisons, "is_not");
    const isContains = getComparisonSafely(comparisons, "contains");
    const isNotContains = getComparisonSafely(comparisons, "not_contains");
    const hasAllOf = getComparisonSafely(comparisons, "has_all_of");
    const hasAnyOf = getComparisonSafely(comparisons, "has_any_of");
    const isExactly = getComparisonSafely(comparisons, "is_exactly");
    const hasNoneOf = getComparisonSafely(comparisons, "has_none_of");
    const isNoneOf = getComparisonSafely(comparisons, "is_none_of");
    const targetComparisonsMap = {
        colorpickerfield: {
            is: (0, comparisons_1.flattenList)(is),
            is_not: (0, comparisons_1.flattenList)(isNot),
            contains: (0, comparisons_1.flattenList)(isContains),
            not_contains: (0, comparisons_1.flattenList)(isNotContains),
        },
        userfield: {
            contains: (0, comparisons_1.flattenList)((0, comparisons_1.joinList)(isContains)),
            not_contains: (0, comparisons_1.flattenList)((0, comparisons_1.joinList)(isNotContains)),
        },
        statusfield: {
            is_not_completed: (0, comparisons_1.forListSomeOrEmpty)(isNoneOf),
        },
        yesnofield: {
            is: lookupYesNoIsComparison(comparisons),
        },
    };
    return {
        ...(0, mapValues_1.default)(comparisons, (generator, comparison) => 
        // Use the target field's comparison functions,
        // but apply them to values in the list. Use Array#every for negative
        // comparisons and Array#some for others
        (0, exports.isNegativeComparison)(comparison)
            ? (0, comparisons_1.forListEvery)(generator)
            : (0, comparisons_1.forListSome)(generator)),
        ...targetComparisonsMap[fieldType],
        has_all_of: (0, comparisons_1.flattenList)(hasAllOf),
        has_any_of: (0, comparisons_1.flattenList)(hasAnyOf),
        has_none_of: (0, comparisons_1.flattenList)(hasNoneOf),
        is_exactly: (0, comparisons_1.uniqueList)((0, comparisons_1.flattenList)(isExactly)),
        is_empty: (0, comparisons_1.flattenList)(comparisons_1.isEmptyList),
        is_not_empty: (0, comparisons_1.flattenList)(comparisons_1.isNotEmptyList),
    };
};
exports.getLookupComparisonsForTargetField = getLookupComparisonsForTargetField;
